import React, { useEffect } from 'react';
import Stopper from '@/errorManagement/errorPages/default';
import OneTrust from '@/bit/components/components.one-trust-x';
import { ErrorBoundary } from 'react-error-boundary';
import { reportJSError } from '@/utils/common';
import { useSelector } from 'react-redux';
import AppController from '@/components/appController';
import RouteHandler from '@/bit/core/core.route-handler';
import { wrapper } from '@/store';
import Script from 'next/script';
import '@/styles/globals.css';
import '@/styles/globalVars.scss';

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 

function App({ Component, pageProps }) {
  const { Modal, modalHistory } = useSelector((state) => state.modals);
  const context = useSelector((state) => state.main.context);
  const logError = (jsError) => {
    try {
      reportJSError(jsError, 'errorBoundary', 'pages/_app', context);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    // para que se quede el carro sticky al cerrar un modal
    if (modalHistory.length === 0) {
      document.documentElement.removeAttribute('style');
      document.body.removeAttribute('style');
    }
  }, [modalHistory.length]);
  return (
    <ErrorBoundary FallbackComponent={Stopper} onError={logError}>
      <Script
        src="https://maps.googleapis.com/maps/api/js?key=AIzaSyDXRBpTD7TcAN9WXSRySKFpZet8TZitduw&libraries=places"
        strategy="lazyOnload"
      />
      <RouteHandler />
      <AppController {...pageProps}>
        <Component {...pageProps} />
      </AppController>
      {Modal && Modal}
      <OneTrust />
    </ErrorBoundary>
  );
}

export default wrapper.withRedux(App);
